module.exports = __webpack_public_path__ + "img/icon3.fe756671.png";